export default __webpack_public_path__ + "static/media/draft.52478012.svg";